var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseeye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1428 14.8601C13.7442 15.9262 12.0412 16.5168 10.2828 16.5455C4.55556 16.5455 1.28284 10.0001 1.28284 10.0001C2.30057 8.10343 3.71213 6.44638 5.42284 5.14007M8.56465 3.65097C9.12784 3.51915 9.70443 3.45325 10.2828 3.45461C16.0101 3.45461 19.2828 10.0001 19.2828 10.0001C18.7862 10.9292 18.1939 11.8039 17.5156 12.6101M12.0174 11.7346C11.7927 11.9758 11.5217 12.1692 11.2206 12.3033C10.9195 12.4375 10.5945 12.5096 10.2649 12.5155C9.93534 12.5213 9.60797 12.4606 9.30234 12.3372C8.9967 12.2137 8.71906 12.03 8.48598 11.7969C8.2529 11.5638 8.06916 11.2862 7.94571 10.9806C7.82226 10.6749 7.76163 10.3476 7.76745 10.018C7.77326 9.68842 7.8454 9.36339 7.97955 9.0623C8.11371 8.76122 8.30713 8.49023 8.54829 8.26552",
    stroke: "#9D98A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28284 1L19.2828 19",
    stroke: "#9D98A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseeye);
export default __webpack_public_path__ + "static/media/closeeye.b93ae5bb4cc8e58861a87a28440e8205.svg";
export { ForwardRef as ReactComponent };